import { MappedNotification } from 'common/header/notifications/Notifications.types';
import { getMetaData } from 'common/header/notifications/hooks/Notification.utils';

export const getWorkflowTitle = (notificationViewModel: Partial<MappedNotification>): Partial<MappedNotification> => {
  const metadata = getMetaData(notificationViewModel);
  return {
    title: metadata.find((e) => e?.key === 'SUBJECT')?.value ?? '',
    description: metadata.find((e) => e?.key === 'BODY')?.value ?? ''
  };
};
